import { createContext } from "react";

const AppContext = createContext({
  isEU: false,
  dateFormat: "MM/dd/yyyy",
  momentDateFormat: "MM/DD/YYYY",
});

export { AppContext as default };
